<template id="flow-template">
  <div class="homeview-realtime-data">
    <div class="titleInfo">
      <div class="redDot scaleBlock"></div>
      Live 实时数据
    </div>
    <div class="flowCircleOne">
      <div class="oneLine" v-for="(item, index) in realtimeData" :key="index">
        <div class="title">{{ item.name }}</div>
        <div class="circle-chart picon">
          <div
            class="task-item"
            v-bind:class="{
              item1: item.key == 'WD' || item.key == 'PM10',
              item2: item.key == 'SD' || item.key == 'PM25',
              item3: item.key == 'FYLZ' || item.key == 'ZS',
            }"
          >
            <div class="task-icon-wrapper" style="flex-direction: column">
              <div style="text-align: center">平均</div>
              <div style="text-align: center">{{ item.value }}</div>
              <div class="task-icon"></div>
            </div>
          </div>
        </div>
        <div class="rightInfo">
          <div class="rightSecInfo">
            <div class="infoLine">
              <span>最高</span>
              <span>{{ item.arr[0].name }}</span>
              <span>{{ item.arr[0].value }}{{ item.after }}</span>
            </div>
            <div class="infoLine">
              <span>最低</span>
              <span>{{ item.arr[1].name }}</span>
              <span>{{ item.arr[1].value }}{{ item.after }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="enTitle">环境预警</div>
    <div>
      <div class="textLine" v-for="(item, index) in tableData" :key="index">
        <el-tooltip placement="top">
          <div slot="content">
            {{ item.CreateTime | formatDate
            }}{{ item.AlerteLevel | getAlertLevel }}{{ item.Content }}
          </div>
          <div>
            {{ item.CreateTime | formatDate
            }}{{ item.AlerteLevel | getAlertLevel }}{{ item.Content }}
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../../../../api/src/earlyMsg.js";
import { weatherLook, weatherAlertPage } from "../../../../../../request/api";
import { getMsgList } from "../../../../../../request/msgApi";
export default {
  name: "ScienceLeft",
  componentName: "ScienceLeft",
  data() {
    return {
      realtimeData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
    };
  },
  filters: {
    getAlertLevel(val) {
      let result = "";
      if (val == "3") {
        result = "<蓝色预警>";
      } else if (val == "5") {
        result = "<黄色预警>";
      } else if (val == "7") {
        result = "<橙色预警>";
      } else {
        result = "<红色预警>";
      }
      return result;
    },
    formatDate(val) {
      // 获取单元格数据
      let data = val;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
  created() {
    //环境监测
    this.getWeatherLook();
    this.getNewMsg();
  },
  mounted() {},
  methods: {
    getWeatherLook() {
      let _this = this;
      let params = {};
      weatherLook(params).then((res) => {
        console.log("环境监测");
        console.log(res);
        if (res.code == 0) {
          let circle = res.data;
          for (let key in circle) {
            if (key == "WD") {
              let obj = {
                name: "温度",
                key: "WD",
                value: circle[key] + "℃",
                after: "℃",
                arr: [],
              };
              obj.arr.push(circle.WDmax[0]);
              obj.arr.push(circle.WDmin[0]);
              _this.realtimeData.push(obj);
            } else if (key == "SD") {
              let obj = {
                name: "湿度",
                key: "SD",
                value: circle[key] + "%",
                after: "%",
                arr: [],
              };
              obj.arr.push(circle.SDmax[0]);
              obj.arr.push(circle.SDmin[0]);
              _this.realtimeData.push(obj);
            } else if (key == "QY") {
              //  let obj={
              //    name:"气压",
              // key:"QY",
              //    value:circle[key]+"KPa",
              //    after:"KPa",
              //    arr:[]
              //  }
              //  obj.arr.push(circle.QYmax[0])
              //  obj.arr.push(circle.QYmin[0])
              //  _this.realtimeData.push(obj)
            } else if (key == "FYLZ") {
              let obj = {
                name: "负氧离子",
                key: "FYLZ",
                value: circle[key] + "个",
                after: "个",
                arr: [],
              };
              obj.arr.push(circle.FYLZmax[0]);
              obj.arr.push(circle.FYLZmin[0]);
              _this.realtimeData.push(obj);
            } else if (key == "PM25") {
              let obj = {
                name: "PM2.5",
                key: "PM25",
                value: circle[key] + "μg/m³",
                after: "μg/m³",
                arr: [],
              };
              obj.arr.push(circle.PM25max[0]);
              obj.arr.push(circle.PM25min[0]);
              _this.realtimeData.push(obj);
            } else if (key == "PM10") {
              let obj = {
                name: "PM10",
                key: "PM10",
                value: circle[key] + "μg/m³",
                after: "μg/m³",
                arr: [],
              };
              obj.arr.push(circle.PM10max[0]);
              obj.arr.push(circle.PM10min[0]);
              _this.realtimeData.push(obj);
            } else if (key == "ZS") {
              let obj = {
                name: "噪声",
                key: "ZS",
                value: circle[key] + "dB",
                after: "dB",
                arr: [],
              };
              obj.arr.push(circle.ZSmax[0]);
              obj.arr.push(circle.ZSmin[0]);
              _this.realtimeData.push(obj);
            }
          }
          //  console.log('_this.realtimeData')
          //  console.log(_this.realtimeData)
          //  _this.realtimeData = res.data;
        }
      });
    },
    getNewMsg() {
      let that = this;

      let searchInfo = {
        PageSize: 10000,
        PageIndex: 1,
        AlertType: "20",
      };
      new MyApis()
        .GetAlertItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
div.flowCircleOne {
  padding-top: 5%;
}
.colorblue {
  color: #00bdff;
}
.colorred {
  color: #fd4d4e;
}
.coloryellow {
  color: #fedb4e;
}
.titleInfo {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #2ac1ff;
  padding-left: 40px;
  position: relative;
  margin-top: 15px;
  .redDot {
    position: absolute;
    left: 20px;
    top: 4px;
    width: 16px;
    height: 16px;
    background: url("../../../theme-default/src/img/red_dot.png");
  }
}
.enTitle {
  margin: 0 auto;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  margin-top: 2rem;
  background-image: linear-gradient(
    90deg,
    rgba(9, 36, 75, 0.4) 0%,
    rgba(17, 58, 116, 0.71) 26%,
    #174d9a 50%,
    rgba(24, 79, 157, 0.98) 52%,
    rgba(17, 58, 116, 0.69) 76%,
    rgba(9, 36, 75, 0.4) 100%
  );
  //  opacity: 0.25;
  font-size: 16px;
  color: #2ac1ff;
  text-indent: 2.6rem;
}
.textLine {
  width: 90%;
  height: 2.8rem;
  line-height: 2.8rem;
  background-color: rgba(32, 223, 220, 0.1);
  color: #00c6ff;
  font-size: 14px;
  margin: 10px auto;
  padding: 0px 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.flexbox {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.oneLine {
  position: relative;
  .title {
    font-size: 1.4rem;
    margin: 2rem 5.8rem 1rem;
    font-weight: bold;
  }
  .picon {
    position: absolute;
    left: 1rem;
    bottom: -2rem;
  }
}
.rightInfo {
  padding-left: 6rem;
}
.rightSecInfo {
  height: 10rem;
  padding: 1rem 0.9rem;
  padding-left: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(
    90deg,
    rgba(15, 36, 69, 0.1) 0%,
    rgba(17, 58, 116, 0.3) 26%,
    rgba(17, 58, 116, 0.4) 76%,
    rgba(9, 36, 75, 0.1) 100%
  );
}
.infoLine {
  font-size: 1.4rem;
  letter-spacing: 0px;
  color: #23c3ff;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>